import React, { useState } from 'react';
import { Layout, Button } from 'antd';
import { API_URL } from "../constant";


const OPTins: React.FC = () => {

  return (
    <div style={{ height: '100%' }}>
      
    </div>
  );
};

export default OPTins;
